import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import DeleteAssetsService from "../../services/contract/asset/deleteAssetService";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import AddAssets from "../../Layouts/contracts/components/Asset/add-assets";
import EditAssets from "../../Layouts/contracts/components/Asset/editAsset";
import ViewAssets from "../../Layouts/contracts/components/Asset/viewAssets";
import { useNavigate } from "react-router-dom";


function AssetList({ id, contracttype, setTab, party_id }) {

	const [hideshow, setHideShow] = useState(false)
	const [hideshowedit, setHideShowEdit] = useState(false)
	const [hideshowview, setHideShowView] = useState(false)
	const [items, setItems] = useState([]);
	const [assetid, setAssetID] = useState("");
	const [asset_type, setAssetType] = useState("");
	const [asset_typesetting, setAssetSettingType] = useState("");
	let navigate = useNavigate();


	const hideshowstate = (asset) => {
		if (asset.assettype !== "") {
			setAssetType(asset.assettype)
			setHideShow(true)
		}
		else {
			setHideShow(true)
		}
	}

	const handleView = (asset_id) => {
		setAssetID(asset_id)
		setHideShowView(true)
	}

	const handleEdit = (asset_id) => {
		setAssetID(asset_id)
		setHideShowEdit(true)
	}

	const handelDefault = () => {
		let url = API + "contracts/asset-view/" + id + "/";
		axios.get(url, { headers: authHeader() })
			.then(response => setItems(response.data.data))
	}

	const handlefinanced = () => {
		let url = API + "contracts/financedamount/" + id + "/";
		axios.get(url, { headers: authHeader() })
			.then(response => console.log("data", response.data))
	}

	const asset_number_method = async () => {
		await axios.get(
			API + `contracts/asser_number_series/`, { headers: authHeader() }
		)
			.then((response) => {
				if (response.data.success === 1) {
					setAssetType(response.data.assettype.split(", "))
					setAssetSettingType(response.data.assettype)
				}
				else {
					return false
				}
			})
	}

	useEffect(() => {
		handelDefault();
		asset_number_method()
	}, []);

	const handelDelete = (id) => {
		confirmAlert({
			title: '',
			message: 'Are you sure you want to delete this Asset?.',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						DeleteAssetsService.deleteassets(id).then(
							(response) => {
								if (response.data.success) {
									toast.success(`${response.data.response}`, {
										position: "top-right",
										autoClose: 1000,
										hideProgressBar: false,
										pauseOnHover: true,
										draggable: true,
										progress: undefined,
										theme: "light",
									})
									handelDefault();
									handlefinanced()
								} else {
									toast.error(`${response.data.error}`,
										{
											position: "top-right",
											autoClose: 1000,
											hideProgressBar: false,
											pauseOnHover: true,
											draggable: true,
											progress: undefined,
											theme: "light",
										})
								}
							},
						)
					}
				},
				{
					label: 'No',
				}
			]
		});
	}

	return (
		<>
			<ToastContainer />
			{
				hideshow === false ?
					hideshowedit === false ?
						hideshowview === false ?
							<div className="row py-2">
								<div className="col-md-12">
									<div className=" mb-0">
										<div className="header pb-0">
											<div className="d-lg-flex">
												<div>
													<h5 className="mb-0">{t("Assets")}
													</h5>
												</div>
												<div className="ms-auto my-auto mt-lg-0 mt-4">
													{asset_type.length === 1 ?
														<div className="ms-auto my-auto">
															<button className="btn btn-primary  mb-0" onClick={hideshowstate}>+&nbsp; New Asset</button>
														</div> :
														<div className="dropdown">
															<button className="btn btn-primary mb-0 dropdown-toggle" data-bs-toggle="dropdown"
																type="button" >+&nbsp;{t('New Asset')}
															</button>
															<ul style={{ padding: "15px" }} className="dropdown-menu ">
																<li><span onClick={() => hideshowstate({ assettype: "Vehicle" })} >Vehicle</span></li>
																<li><span onClick={() => hideshowstate({ assettype: "Equipment" })}>Equipment</span></li>
															</ul>
														</div>
													}
												</div>
											</div>
										</div>
										<div className="body">
											<div className="p-0">
												{
													contracttype === "Loan" ?
														<MaterialTable
															style={{
																padding: "0.5rem 0.5rem", backgroundColor: "var(--bs-table-bg)",
																borderBottomWidth: "1px",
																boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
															}}
															onRowClick={(event, rowData) => {
																handleView(rowData.id)
															}}
															columns={[
																{
																	title: `${t("Asset No")}`,
																	field: "asset_number",
																	headerStyle: {
																		verticalAlign: "inherit",
																		fontWeight: "bold",
																		textAlign: "left"
																	},
																	cellStyle: {
																		textAlign: "left",
																		fontSize: 12
																	},
																	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Asset No")}</div> <div className="hyperlink">{(rowData.asset_number)}</div></>
																},
																{
																	title: `${t("Asset Description")}`,
																	field: "asset_desc",
																	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Asset Description")}</div><div>{rowData.asset_desc ? rowData.asset_desc : "None"}</div></>,
																	headerStyle: {
																		verticalAlign: "inherit",
																		fontWeight: "bold",
																		textAlign: "left"
																	},
																	cellStyle: {
																		textAlign: "left",
																		fontSize: 12
																	}
																},
																{
																	title: `${t("Asset Reference")}`,
																	field: "asset_ref",
																	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Asset Reference")}</div><div>{rowData.asset_ref ? rowData.asset_ref : "None"}</div></>,
																	headerStyle: {
																		verticalAlign: "inherit",
																		fontWeight: "bold",
																		textAlign: "left"
																	},
																	cellStyle: {
																		textAlign: "left",
																		fontSize: 12
																	}
																},
																 {
																title: `${t("Financed Amount")}`,
																field: "financed_amount",
																render: rowData => <>
																	<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																	>{t("Financed Amount")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.financed_amount)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																//     textAlign: "right",
																//     fontSize: 12
																// }
															},
																{
																title: `${t("Item Number")}`,
																field: "item_number",
																render: rowData => <>
																	<div className="d-xl-none tc d-md-none d-lg-none">{t("Item Number")}</div><div className="hyperlink" onClick={() => navigate(`/itemmasterview`, { state: rowData.item_master })}>{rowData.item_number}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
																{
																title: `${t("Item Category")}`,
																field: "item_category",
																render: rowData => <>
																	<div className="d-xl-none tc d-md-none d-lg-none">{t("Item Category")}</div><div className="" >{rowData.item_category}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
																{
																title: `${t("Item Sub Category")}`,
																field: "item_sub_category",
																render: rowData => <>
																	<div className="d-xl-none tc d-md-none d-lg-none">{t("Item Sub Category")}</div><div className="" >{rowData.item_sub_category}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},

															{
																title: `${t("Item Status")}`,
																field: "item_status",
																render: rowData => <>
																	<div className="d-xl-none tc d-md-none d-lg-none">{t("Item Status")}</div><div>{rowData.item_status ? (rowData.item_status) : ""}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Installed Location")}`,
																field: "address_name.address_line_1",
																render: rowData => <>
																	<div className="d-xl-none tc d-md-none d-lg-none">{t("Installed Location")}</div><div>{rowData.address_name ? (rowData.address_name.address_line_1) : ""}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
																// {
																// 	title: `${t("VIN Number")}`,
																// 	field: "vin_number",
																// 	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("VIN Number")}</div><div>{rowData.vin_number ? rowData.vin_number : "None"}</div></>,
																// 	// export: false,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
																// {
																// 	title: `${t("Vehicle Cost")}`,
																// 	field: "vehicle_cost",
																// 	render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																// 	>{t("Vehicle Cost")}</div>
																// 		<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.vehicle_cost)}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "right"
																// 	},
																// 	// cellStyle: {
																// 	// 	textAlign: "right",
																// 	// 	fontSize: 12
																// 	// }
																// },
																// {
																// 	title: `${t("Dealer Payable")}`,
																// 	field: "dealer_payable",
																// 	render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																// 	>{t("Dealer Payable")}</div> <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.dealer_payable)}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "right"
																// 	},
																// 	// cellStyle: {
																// 	// 	textAlign: "right",
																// 	// 	fontSize: 12
																// 	// }
																// },

																// {
																// 	title: `${t("In Service Date")}`,
																// 	field: "in_service_date",
																// 	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("In Service Date")}</div><div>{rowData.in_service_date ? Helper.DateNormal(rowData.in_service_date) : "None"}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
																// {
																// 	title: `${t("Item Number")}`,
																// 	field: "item_number",
																// 	render: rowData => <>
																// 		<div className="d-xl-none tc d-md-none d-lg-none">{t("Item Number")}</div><div
																// 		className="hyperlink"
																// 			onClick={() => rowData.item_number ? navigate(`/itemmasterview`, { state: rowData.item_master }) : ""}

																// 		>{rowData.item_number}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
																// {
																// 	title: `${t("Status")}`,
																// 	field: "status",
																// 	render: rowData => <>
																// 		<div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div><div>{rowData.status ? (rowData.status) : ""}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
															]}
															data={items}
															actions={[
																{
																	icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" />,
																	tooltip: "Edit",
																	onClick: (event, rowData) => {
																		handleEdit(rowData.id)
																	}
																},
																{
																	icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'} alt="Delete" />,
																	tooltip: "Edit",
																	onClick: (event, rowData) => { handelDelete(rowData.id) }
																}
															]}
															options={{
																headerStyle: {
																	backgroundColor: "white",
																	color: "#245C7F",
																	fontSize: 12,
																},
																rowStyle: (rowData, index) => {
																	if (index % 2) {
																		return { backgroundColor: "#fff" }
																	}
																},
																sorting: true,
																search: false,
																toolbar: false,
																paging: true,
																pageSize: 3,       // make initial page size
																emptyRowsWhenPaging: false,   // To avoid of having empty rows
																pageSizeOptions: [3, 15, 20, 50],
																paginationType: "stepped",
																showFirstLastPageButtons: false,
																actionsColumnIndex: -1,
															}}
														/> :
														<MaterialTable
															style={{
																padding: "0.5rem 0.5rem", backgroundColor: "var(--bs-table-bg)",
																borderBottomWidth: "1px",
																boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
															}}
															onRowClick={(event, rowData) => {
																handleView(rowData.id)
															}}
															columns={[
																{
																	title: `${t("Asset No")}`,
																	field: "asset_number",
																	headerStyle: {
																		verticalAlign: "inherit",
																		fontWeight: "bold",
																		textAlign: "left"
																	},
																	cellStyle: {
																		textAlign: "left",
																		fontSize: 12
																	},
																	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Asset No")}</div> <div className="hyperlink">{(rowData.asset_number)}</div></>
																},
																{
																	title: `${t("Asset Description")}`,
																	field: "asset_desc",
																	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Asset Description")}</div><div>{rowData.asset_desc ? rowData.asset_desc : "None"}</div></>,
																	headerStyle: {
																		verticalAlign: "inherit",
																		fontWeight: "bold",
																		textAlign: "left"
																	},
																	cellStyle: {
																		textAlign: "left",
																		fontSize: 12
																	}
																},
																{
																	title: `${t("Asset Reference")}`,
																	field: "asset_ref",
																	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Asset Reference")}</div><div>{rowData.asset_ref ? rowData.asset_ref : "None"}</div></>,
																	headerStyle: {
																		verticalAlign: "inherit",
																		fontWeight: "bold",
																		textAlign: "left"
																	},
																	cellStyle: {
																		textAlign: "left",
																		fontSize: 12
																	}
																},
																 {
                                                                title: `${t("Financed Amount")}`,
                                                                field: "financed_amount",
                                                                render: rowData => <>
                                                                    <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                                                    >{t("Financed Amount")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.financed_amount)}</div></>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "right"
                                                                },
                                                                // cellStyle: {
                                                                //     textAlign: "right",
                                                                //     fontSize: 12
                                                                // }
                                                            },
                                                              {
                                                                title: `${t("Item Number")}`,
                                                                field: "item_number",
                                                                render: rowData => <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Number")}</div><div className="hyperlink" onClick={() => navigate(`/itemmasterview`, { state: rowData.item_master })}>{rowData.item_number}</div></>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left"
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12
                                                                }
                                                            },
                                                              {
                                                                title: `${t("Item Category")}`,
                                                                field: "item_category",
                                                                render: rowData => <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Category")}</div><div className="" >{rowData.item_category}</div></>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left"
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12
                                                                }
                                                            },
                                                              {
                                                                title: `${t("Item Sub Category")}`,
                                                                field: "item_sub_category",
                                                                render: rowData => <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Sub Category")}</div><div className="" >{rowData.item_sub_category}</div></>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left"
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12
                                                                }
                                                            },

                                                            {
                                                                title: `${t("Item Status")}`,
                                                                field: "item_status",
                                                                render: rowData => <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Status")}</div><div>{rowData.item_status ? (rowData.item_status) : ""}</div></>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left"
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12
                                                                }
                                                            },
                                                            {
                                                                title: `${t("Installed Location")}`,
                                                                field: "address_name.address_line_1",
                                                                render: rowData => <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Installed Location")}</div><div>{rowData.address_name ? (rowData.address_name.address_line_1) : ""}</div></>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left"
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12
                                                                }
                                                            },
																// {
																// 	title: `${t("VIN Number")}`,
																// 	field: "vin_number",
																// 	render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("VIN Number")}</div><div>{rowData.vin_number ? rowData.vin_number : "None"}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
																// {
																// 	title: `${t("Vehicle Cost")}`,
																// 	field: "vehicle_cost",
																// 	render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																// 	>{t("Vehicle Cost")}</div>
																// 		<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.vehicle_cost)}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "right"
																// 	},
																// 	// cellStyle: {
																// 	// 	textAlign: "right",
																// 	// 	fontSize: 12
																// 	// }
																// },
																// {
																// 	title: `${t("Dealer Payable")}`,
																// 	field: "dealer_payable",
																// 	render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																// 	>{t("Dealer Payable")}</div> <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.dealer_payable)}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "right"
																// 	},
																// 	// cellStyle: {
																// 	// 	textAlign: "right",
																// 	// 	fontSize: 12
																// 	// }
																// },

																// {
																// 	title: `${t("Residual Value")}`,
																// 	field: "residal_value",
																// 	render: rowData => <>
																// 		<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																// 		>{t("Residual Value")}</div>
																// 		<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.residal_value)}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "right"
																// 	},
																// 	// cellStyle: {
																// 	// 	textAlign: "right",
																// 	// 	fontSize: 12
																// 	// }


																// },
																// {
																// 	title: `${t("In Service Date")}`,
																// 	field: "in_service_date",
																// 	render: rowData => <>
																// 		<div className="d-xl-none tc d-md-none d-lg-none">{t("In Service Date")}</div><div>{rowData.in_service_date ? Helper.DateNormal(rowData.in_service_date) : "None"}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
																// {
																// 	title: `${t("Item Number")}`,
																// 	field: "item_number",
																// 	render: rowData => <>
																// 		<div className="d-xl-none tc d-md-none d-lg-none">{t("Item Number")}</div><div className="hyperlink"
																// 			onClick={() => rowData.item_number ? navigate(`/itemmasterview`, { state: rowData.item_master }) : ""}
																// 		>{rowData.item_number}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
																// {
																// 	title: `${t("Status")}`,
																// 	field: "status",
																// 	render: rowData => <>
																// 		<div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div><div>{rowData.status ? (rowData.status) : ""}</div></>,
																// 	headerStyle: {
																// 		verticalAlign: "inherit",
																// 		fontWeight: "bold",
																// 		textAlign: "left"
																// 	},
																// 	cellStyle: {
																// 		textAlign: "left",
																// 		fontSize: 12
																// 	}
																// },
															]}
															data={items}
															actions={[
																{
																	icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" />,
																	tooltip: "Edit",
																	onClick: (event, rowData) => {
																		handleEdit(rowData.id)
																	}
																},
																{
																	icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'} alt="Delete" />,
																	tooltip: "Edit",
																	onClick: (event, rowData) => { handelDelete(rowData.id) }
																}
															]}
															options={{
																headerStyle: {
																	backgroundColor: "white",
																	color: "#245C7F",
																	fontSize: 12,
																},
																rowStyle: (rowData, index) => {
																	if (index % 2) {
																		return { backgroundColor: "#fff" }
																	}
																},
																sorting: true,
																search: false,
																toolbar: false,
																paging: true,
																pageSize: 3,       // make initial page size
																emptyRowsWhenPaging: false,   // To avoid of having empty rows
																pageSizeOptions: [3, 15, 20, 50],
																paginationType: "stepped",
																showFirstLastPageButtons: false,
																actionsColumnIndex: -1,
															}}
														/>

												}

											</div>
										</div>
									</div>
								</div>
							</div>
							:
							<ViewAssets asset_id={assetid} id={id} contracttype={contracttype} />
						:
						<EditAssets asset_id={assetid} contractId={id} contract_term={contracttype} party_id={party_id} />
					:
					<AddAssets contract_id={id} contract_type={contracttype} tabindex={setTab} party_id={party_id} assettypesetting={asset_type ? asset_type : asset_typesetting} />
			}
		</>
	)
}
export default AssetList
